import { render, staticRenderFns } from "./SpadN_Total.vue?vue&type=template&id=621c0086"
import script from "./SpadN_Total.vue?vue&type=script&lang=js"
export * from "./SpadN_Total.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports